import * as yup from "yup";

/**
 * Validate user personal data
 * @returns
 */
export const validatePersonalData = () => {
  return yup.object({
    title: yup.string(),
    firstName: yup
      .string()
      .required("Please the first name is required")
      .min(3, "This first name field is should be at least 3 characters"),
    lastName: yup
      .string()
      .required("Please the last name is required")
      .min(3, "This last name field is should be at least 3 characters"),
    userName: yup.string().required("Please the username is required"),
  });
};

/**
 * user assignment role validation
 * @returns
 */
export const validateAssignment = () => {
  return yup.object({
    facility: yup
      .object({
        facilityId: yup.string().required("Please select a facility"),
        facilityName: yup.string().required("Please select a facility"),
      })
      .nullable(true),
    role: yup
      .object({
        roleName: yup.string().required("Please select a role"),
        roleId: yup.string().required("Please select a role"),
      })
      .nullable(true),
    profile: yup
      .object({
        profileName: yup.string().required("Please select a Profile"),
        profileId: yup.string().required("Please select a Profile"),
      })
      .nullable(),
  });
};

/**
 * Validate user personal data
 * @returns
 */
export const validateEmail = () => {
  return yup.object({
    email: yup.string().email("Please include a valid email"),
    // Backstop for the disabled Continue button: an entered email must be confirmed.
    checked: yup.boolean().when("email", {
      is: (email?: string) => !!email?.trim(),
      then: (schema) =>
        schema.oneOf([true], "Please confirm this isn't a personal email"),
    }),
  });
};
